<template>
  <div id="management">
    <div class="header flex-between">
      <div class="header-text">
        <h1>会员积分查询</h1>
      </div>

      <div class="header-button">
        <el-button icon="iconfont icon-sousuo1" v-if="jurisdiction.search" @click="searchBtn"
          >查询</el-button
        >
      </div>
    </div>
    <el-card shadow="never">
      <div class="searchform">
        <el-form :model="formInline" size="small" label-width="180px">
          <el-row>
            <el-col :span="8">
              <el-form-item label="会员(手机号\姓名\会员卡)">
                <el-input v-model="formInline.search" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="所属区域">
                <el-select style="width: 100%" v-model="formInline.regionID">
                  <el-option
                    v-for="item in optionsRegion"
                    :key="item.id"
                    :value="item.id"
                    :label="item.lable"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="所属门店">
                <el-select style="width: 100%" v-model="formInline.shopID">
                  <el-option
                    v-for="item in optionsShop"
                    :key="item.shopID"
                    :label="item.shopCode"
                    :value="item.shopID"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-card>
    <el-card shadow="never">
      <el-table
        size="small"
        height="630px"
        class="table-style"
        border
        :row-class-name="tableRowClassName"
        :header-cell-style="{
          background: '#FCFBF2',
          color: '#6C6839',
          'text-align': 'center',
          fontSize: '14px',
        }"
        :cell-style="{ 'text-align': 'center' }"
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        v-el-table-infinite-scroll="load"
        v-loading="loading"
        infinite-scroll-disabled="onLoading"
      >
        <el-table-column width="50" type="index"></el-table-column>
        <el-table-column width="80">
          <template slot-scope="scope">
            <div
              style="text-decoration: underline; color: #a19b59"
              @click="xiMing(scope.row.custID)"
            >
              明细流水
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="custName" label="会员姓名"> </el-table-column>
        <el-table-column prop="cardNo" label="会员卡号"> </el-table-column>
        <el-table-column prop="levelName" label="会员等级"> </el-table-column>
        <el-table-column prop="regionName" label="所属区域"></el-table-column>
        <el-table-column prop="shopName" label="所属门店"> </el-table-column>
        <el-table-column prop="mobile" label="移动电话"> </el-table-column>
        <el-table-column
          prop="currAvailPoint"
          label="会员有效积分"
        ></el-table-column>
        <el-table-column prop="pendingPoints" label="会员待有效积分">
        </el-table-column>
      </el-table>
      <el-alert
        v-if="isMore"
        title="没有更多数据了!"
        type="warning"
        center
        :closable="false"
      >
      </el-alert>
    </el-card>
    <el-dialog :visible.sync="dialogVisible" width="75%">
      <el-card shadow="never">
        <el-table
          size="small"
          height="580px"
          class="table-style"
          border
          :row-class-name="tableRowClassName"
          :header-cell-style="{
            background: '#FCFBF2',
            color: '#6C6839',
            'text-align': 'center',
            fontSize: '14px',
          }"
          :cell-style="{ 'text-align': 'center' }"
          ref="multipleTable"
          :data="xiMingData"
          tooltip-effect="dark"
          v-el-table-infinite-scroll="xiMingLoad"
          v-loading="xiMingLoading"
          infinite-scroll-disabled="onLoadingMX"
        >
          <el-table-column width="50" type="index"></el-table-column>
          <el-table-column prop="custName" label="会员姓名"> </el-table-column>
          <el-table-column prop="cardNO" label="会员卡号"> </el-table-column>
          <el-table-column prop="levelName" label="会员等级"> </el-table-column>
          <el-table-column prop="regionName" label="所属区域"></el-table-column>
          <el-table-column prop="shopName" label="所属门店"> </el-table-column>
          <el-table-column prop="mobile" label="移动电话"> </el-table-column>
          <el-table-column prop="chgKind" label="积分类型">
            <template slot-scope="scope">
                {{
                  scope.row.chgKind===0?"销售积分":
                  scope.row.chgKind===1?"补积分(补积分)":
                  scope.row.chgKind===2?"补积分(CRM)":
                  scope.row.chgKind===3?"积分过期":
                  scope.row.chgKind===4?"营销积分":
                  scope.row.chgKind===5?"积分兑换":
                  scope.row.chgKind===6?"外部行为积分":
                  "积分兑换废弃"
                }}
            </template>
          </el-table-column>
          <el-table-column prop="points" label="本次积分"> </el-table-column>
          <el-table-column prop="saleNO" label="销售单号"> </el-table-column>
          <el-table-column prop="sheetAmount" label="销售金额">
          </el-table-column>
          <el-table-column prop="createTime" label="积分日期">
            <template slot-scope="scope">
              <div v-if="scope.row.createTime !== null">
                {{ scope.row.createTime | dateFormats }}
              </div>
              <div v-else></div>
            </template>
          </el-table-column>
          <el-table-column prop="startDate" label="生效日期">
            <template slot-scope="scope">
              <div v-if="scope.row.startDate !== null">
                {{ scope.row.startDate | dateFormats }}
              </div>
              <div v-else></div>
            </template>
          </el-table-column>
          <el-table-column label="状态">
            <template slot-scope="scope">
                {{scope.row.state==0?"已生效":"未生效"}}
            </template>
          </el-table-column>
          <el-table-column prop="chgNotes" label="备注"> </el-table-column>
        </el-table>
        <el-alert
          v-if="isMorMX"
          title="没有更多数据了!"
          type="warning"
          center
          :closable="false"
        >
        </el-alert>
      </el-card>
    </el-dialog>
  </div>
</template>

<script>
import { getcpyNo } from "@/utils/auth";
import { selectPageApi, flowingWaterApi } from "@/api/user";
import { queryRegionApi, shopSelectByCodeApi } from "@/api/shop";
export default {
  name: "centre",
  data() {
    return {
      dialogVisible: false,
      loading: false,
      xiMingLoading:false,
      modifyLabelAlign: [],
      optionsRegion: [],
      optionsShop: [], // 门店
      tableData: [],
      xiMingData: [],
      pages: 0, // 页码数
      pagesMX: 0, // 页码数
      count: 1,
      countMX: 1,
      formInline: {},
      jurisdiction: {
        search: false,
        create: false,
        edit: false,
        look: false,
        delete: false,
      },
    };
  },
  computed: {
    isMore() {
      return this.count >= this.pages;
    },
    onLoading() {
      return this.loading || this.isMore;
    },
    isMorMX() {
      return this.countMX >= this.pagesMX;
    },
    onLoadingMX() {
      return this.xiMingLoad || this.isMorMX;
    },
  },
  created() {
    this.dataList();
    this.searchListRes();
    this.shopList();
    let Management = JSON.parse(localStorage.getItem("Management"));
    console.log(Management);
    for (let i = 0; i < Management.length; i++) {
      if (Management[i].menuName == "查询") {
        this.jurisdiction.search = true;
        continue;
      }
    }
  },
  methods: {
    // 判断如果是单行就变黄色双行是白色
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "warning-row";
      }
      return "";
    },
    //列表数据
    dataList(type) {
      selectPageApi({
        search: this.formInline.search,
        regionID: this.formInline.regionID,
        shopID: this.formInline.shopID,
        pageNo: this.count,
        pageSize: 50,
      }).then((res) => {
        if (res.message !== "success") return;
        if(type){
          this.tableData=[]
        }
        this.tableData = this.tableData.concat(res.data.list);
        this.pages = res.data.pages;
        this.loading = false;
      });
    },
    load() {
      this.loading = true;
      setTimeout(() => {
        this.count += 1;
        this.dataList();
      }, 1000);
    },
    xiMingLoad() {
      this.xiMingLoading = true;
      setTimeout(() => {
        this.countMX += 1;
        this.xiMing();
      }, 500);
    },
    // 区域查询
    searchListRes() {
      queryRegionApi({
        cpyNO: getcpyNo(),
      }).then((res) => {
        if (res.success) {
          this.optionsRegion.push({
            id: "",
            lable: "全部区域",
          });
          this.optionsRegion = this.optionsRegion.concat(res.data);
        }
      });
    },
    // 门店查询
    shopList() {
      shopSelectByCodeApi({ shopCode: "" }).then((res) => {
       if(res.success){
         this.optionsShop.push({
              shopID:"",
              shopCode:"全部门店"
         })
          this.optionsShop =this.optionsShop.concat(res.data);
          console.log(res.data)
       }
      });
    },
    searchBtn() {
      
      this.loading = true;     
      setTimeout(() => {    
        this.pages = 1;
        this.count = 1;
        this.tableData = []; 
        this.dataList(true);
      }, 500);
    },
    xiMing(value) {
      this.xiMingData=[]
      if (!value) return;
      this.dialogVisible = true;
      flowingWaterApi({
        custID: value,
        pageNo: this.countMX,
        pageSize: 50,
      }).then((res) => {
        console.log(res);
        this.xiMingData = this.xiMingData.concat(res.data.list);
        this.pagesMX = res.data.pages;
        this.xiMingLoading = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
#management {
  height: 100%;
}
.header {
  .header-text {
    height: 30px;
    margin-bottom: 10px;
    color: #76734f;
  }
}
.searchform {
  height: 32px;
  margin-top: 10px;
  line-height: 32px;
}

.centercard {
  margin: 20px;
}
// 按钮边框去掉，文字颜色和加粗
/deep/button {
  border-color: #e6e0af;
  border-radius: 7px;
  color: #a19b59;
}

// input框的背景色和取消圆角

/deep/input {
  border-radius: 0 !important;
}

::v-deep {
  .el-table .warning-row {
    background: #fcfbf2;
  }

  .el-table .success-row {
    background: #ffffff;
  }
  // 改变分页背景色
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #d1cda5 !important;
    color: #ffffff !important;
  }
  // 改变分页字体颜色
  .el-pagination.is-background .btn-next,
  .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .el-pager li {
    color: #d1cda5 !important;
  }
}
</style>
